import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  style: {
    "margin-top": "6%"
  }
};
const _hoisted_2 = {
  key: 0,
  class: "imagetrans-title"
};
const _hoisted_3 = {
  class: "product-content"
};
const _hoisted_4 = {
  class: "row d-flex align-items-center justify-content-center"
};
const _hoisted_5 = {
  class: "col-6 align-items-center justify-content-center",
  style: {
    "display": "flex"
  }
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "row mt-1",
  id: "previewUI",
  style: {
    "display": "none"
  }
};
const _hoisted_8 = {
  class: "col-12 mt-1 text-center"
};
const _hoisted_9 = ["src"];
const _hoisted_10 = {
  ref: "loadingImg"
};
const _hoisted_11 = {
  class: "row mt-2 mb-2 text-center",
  id: "loading-ui",
  style: {
    "display": "none"
  }
};
const _hoisted_12 = {
  class: "col-12 text-center"
};
const _hoisted_13 = ["src"];
const _hoisted_14 = {
  ref: "responsemessage"
};
const _hoisted_15 = {
  key: 0,
  class: "col-12 text-center"
};
const _hoisted_16 = {
  class: "response-content"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [$data.showImagetrans_tile ? (_openBlock(), _createElementBlock("text", _hoisted_2, _toDisplayString($options.Show_Crop_title), 1)) : _createCommentVNode("", true), _createElementVNode("p", _hoisted_3, _toDisplayString($options.Show_Crop_Detail), 1)]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", null, [_createElementVNode("img", {
    src: $data.upload_btn,
    class: "img-fluid",
    id: "upload_btn",
    onClick: _cache[0] || (_cache[0] = $event => $options.handleSelect())
  }, null, 8, _hoisted_6)])])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("img", {
    src: $data.imageUrl,
    class: "img-fluid",
    id: "originalImage",
    style: {
      "max-height": "300px"
    }
  }, null, 8, _hoisted_9), _cache[1] || (_cache[1] = _createElementVNode("div", {
    class: "text-center"
  }, [_createElementVNode("small", {
    id: "upload_hint"
  })], -1))])]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("img", {
    class: "img-fluid",
    src: $data.loading_gif
  }, null, 8, _hoisted_13), _cache[2] || (_cache[2] = _createElementVNode("div", null, [_createElementVNode("small", {
    id: "progressT"
  })], -1))])])], 512), _createElementVNode("div", _hoisted_14, [$data.responseText ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createElementVNode("div", null, [_createElementVNode("p", _hoisted_16, _toDisplayString($data.responseText), 1)])])) : _createCommentVNode("", true)], 512), _renderSlot(_ctx.$slots, "guide", {}, undefined, true)], 64);
}